import { render, staticRenderFns } from "./MagicianShop.vue?vue&type=template&id=3f1fe037&scoped=true&"
import script from "./MagicianShop.vue?vue&type=script&lang=js&"
export * from "./MagicianShop.vue?vue&type=script&lang=js&"
import style0 from "./MagicianShop.vue?vue&type=style&index=0&id=3f1fe037&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1fe037",
  null
  
)

export default component.exports